import {configuration} from '../../configuration'

import Vue from 'vue'
import VueAmplitude from 'vue-amplitude'

import Store from '@/store'

import Storage from '@/helpers/storage'

import gtmFunction from '@/assets/gtmFunction'

import Env from '@/modules/env'
import Firebase from '@/modules/firebase'
import Tracking from '@/modules/tracking'

let CLICK_BLOCKED
let SCREEN_VIEW_BLOCKED

let isEuropeanCountry

export default {

    pageViewAmplitude(vue, page, provider) {
        eventAmplitude(vue, 'screen_view', '', provider, page)
    },

    pageViewGA(vue, page) {
        eventGa('screen_view', {page})
    },

    pageViewAll(vue, page, provider) {
        this.pageViewAmplitude(vue, page, provider)
        this.pageViewGA(vue, page)
    },

    clickAll(vue, target, provider, page, value) {
        this.clickAmplitude(vue, target, provider, page, value)
        this.clickGA(vue, target, provider, value)
    },

    clickAmplitude(vue, target, provider, page, value) {
        eventAmplitude(vue, 'click', target, provider, page, value)
    },

    clickGA(vue, target, provider, value) {
        eventGa('click', {target, provider, page: vue.$store.getters.page, value})
    },

    infoAmplitude(vue, target, provider) {
        eventAmplitude(vue, 'info', target, provider)
    },

    infoGa(vue, target, provider, value) {
        eventGa('info', {target, provider, page: vue.$store.getters.page, value})
    },

    infoAll(vue, target, provider, value) {
        eventAmplitude(vue, 'info', target, provider, null, value)
        eventGa('info', {target, provider, page: vue.$store.getters.page, value})
    },

    popupAmplitude: function (vue, target, provider) {
        eventAmplitude(vue, 'popup', target, provider)
    },

    popupGa: function (vue, target, provider) {
        eventGa('popup', {target, provider, page: vue.$store.getters.page})
    },

    popupAll: function (vue, target, provider) {
        this.popupAmplitude(vue, target, provider)
        this.popupGa(vue, target, provider)
    },

    stateAmplitude(vue, target) {
        eventAmplitude(vue, 'state', target)
    },

    firstProvider(vue, provider) {
        if (vue && vue.$amplitude) {
            vue.$amplitude.setUserProperties({'first_provider': provider})
        }
    },

    errorAmplitude: function (vue, message) {
        eventAmplitude(vue, 'error', message)
    },

    accountCreated: function (provider) {
        eventGa('account_created', {provider})
    },

    accountCreatedAmplitude: function (vue, provider) {
        eventAmplitude(vue, 'account_created', null, provider, 'none')
    },

    accountAssociated: function () {
        eventGa('account_associated')
    },

    accountAssociatedAmplitude: function (vue) {
        eventAmplitude(vue, 'account_associated')
    },

    accountImportedAmplitude: function (vue) {
        eventAmplitude(vue, 'account_imported')
    },

    accountReconnectedAmplitude: function (vue) {
        eventAmplitude(vue, 'account_reconnected')
    },

    accountReconnectedWasInvalidGrantAmplitude: function (vue) {
        eventAmplitude(vue, 'account_reconnected_iv')
    },

    accountReconnectedMagicLinkAmplitude: function (vue) {
        eventAmplitude(vue, 'account_reconnected_magic')
    },

    async initTracking(vue) {

        isEuropeanCountry = await Firebase.getValue('isEea', 'Boolean')

        // Amplitude
        Vue.use(VueAmplitude, {
            apiKey: configuration.tracking.amplitudeKey,
            config: {
                includeUtm: true,
                includeReferrer: true,
                saveParamsReferrerOncePerSession: false
            }
        })

        const properties = Tracking.getTracking()

        vue.$amplitude.getInstance().setUserProperties(properties)

        // GTM

        const scriptGtm = document.createElement('script')

        scriptGtm.innerHTML = gtmFunction
        document.head.appendChild(scriptGtm)


        // GTAG

        const scriptGtag = document.createElement('script')
        scriptGtag.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id="${configuration.tracking.gtagId}">`)
        document.body.appendChild(scriptGtag)
        window.gtag = function gtag() {

            window.dataLayer.push(arguments)
        }

        window.gtag('js', new Date())

        window.gtag('config', configuration.tracking.gtagId, {
            'send_page_view': false,
            'anonymize_ip': true
        })

        let googleConsentRules = {
            'ad_storage': 'denied',
            'analytics_storage': 'denied'
        }

        // add rules for EU user consent policy
        if (isEuropeanCountry) {
            googleConsentRules = {
                ...googleConsentRules,
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
            }
        }

        window.gtag('consent', 'default', googleConsentRules)

        const cookieLawPreferences = Storage.getItem('cookieLawPreferences')

        if (cookieLawPreferences) {

            startCookies()
        }

    },

    updateCookies(result) {

        const refresh = Storage.getItem('cookieLawPreferences')

        const now = Date.now()
        result.forEach(cookie => cookie.since = now)
        const preferencesJson = JSON.stringify(result)

        Storage.setItem('cookieLawPreferences', preferencesJson)

        if (refresh) {
            window.location.reload(true)
        } else {
            startCookies()
        }

        //check conditions
        const adStorage = result.find(item => item.name === 'ad_storage')
        const analyticsStorage = result.find(item => item.name === 'analytics_storage')

        let googleConsentRules = {
            'ad_storage': adStorage && adStorage.active ? 'granted' : 'denied',
            'analytics_storage': analyticsStorage && analyticsStorage.active ? 'granted' : 'denied'
        }

        // add rules for EU user consent policy
        if (isEuropeanCountry) {
            const adUserData = result.find(item => item.name === 'ad_user_data')
            const adPersonalization = result.find(item => item.name === 'ad_personalization')

            googleConsentRules = {
                ...googleConsentRules,
                'ad_user_data': adUserData && adUserData.active ? 'granted' : 'denied',
                'ad_personalization': adPersonalization && adPersonalization.active ? 'granted' : 'denied'
            }
        }

        window.gtag('consent', 'update', googleConsentRules)

    }
}

function eventGa(action, {target, provider, page, value} = {}) {

    const options = {
        'event_category': target,
        'page_view': page,
        'event_label': provider,
        'value': value
    }
    if (Storage.getItem('debugTracking') === '*' || Storage.getItem('debugTracking') === 'ga') {
        console.debug(`gtag ${action} ${Object.values(options)}`)
    }

    if (Env.isProd() && typeof gtag !== 'undefined') {

        gtag('event', action, options)

    }

}

async function eventAmplitude(vue, event, target, provider, page, value) {

    const clickBlocked = await getClickBlocked()
    const screenViewBlocked = await getScreenView()
    if (event === 'click' && clickBlocked.indexOf(`${Store.getters.page};${target}`) > -1) {
        return
    }

    if (event === 'screen_view' && screenViewBlocked.indexOf(page) > -1) {
        return
    }

    if (vue && vue.$amplitude) {

        const obj = {}

        if (target) {
            obj.event_category = target

        }

        if (provider) {
            obj.event_label = provider
        }

        if (page !== 'none') {
            obj.amplitude_screen = page || vue.$store.getters.page
        }

        if (value) {
            obj.value = value
        }

        if (Storage.getItem('debugTracking') === '*' || Storage.getItem('debugTracking') === 'amplitude') {
            console.debug(`amplitude ${event} ${obj.amplitude_screen} ${obj.event_category ? obj.event_category : ''}  ${obj.event_label ? obj.event_label : ''}`)
        }


        if (!Env.isLocal()) {
            try {
                vue.$amplitude.getInstance().logEvent(event, obj)
            } catch (ignored) {
                // do nothing
            }
        }

    }
}

function startCookies() {

    const cookieLawPreferences = Storage.getItem('cookieLawPreferences')

    const cookieLawPreferencesObj = JSON.parse(cookieLawPreferences) || []

    const cookieLawRefuse = cookieLawPreferencesObj.filter(item => !item.active)
    const cookieLawAccept = cookieLawPreferencesObj.filter(item => item.active)

    let cookieLawRefuseStr = ''
    let cookieLawAcceptStr = ''

    cookieLawRefuse.forEach(item => cookieLawRefuseStr = `${cookieLawRefuseStr}-${item.name}`)
    cookieLawAccept.forEach(item => cookieLawAcceptStr = `${cookieLawAcceptStr}-${item.name}`)

    eventGa(`cookie-law-refuse-${cookieLawRefuseStr}-`)
    eventGa(`cookie-law-accept-${cookieLawAcceptStr}-`)
}

async function getClickBlocked() {
    if (!CLICK_BLOCKED) {
        const analyticsBlocked = await Firebase.getValue('analytics_blocked', 'Object')
        CLICK_BLOCKED = analyticsBlocked.click
    }
    return CLICK_BLOCKED || []
}

async function getScreenView() {
    if (!SCREEN_VIEW_BLOCKED) {
        const analyticsBlocked = await Firebase.getValue('analytics_blocked', 'Object')
        SCREEN_VIEW_BLOCKED = analyticsBlocked.screen_view
    }
    return SCREEN_VIEW_BLOCKED || []
}
